import { Company, PartialCompanyRegistration } from "@/types";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";

export function useNormalizedCompany(companyToNormalize: PartialCompanyRegistration | Company) {
  const { t } = useTranslation();

  return useMemo(() => {
    const isPartial = "partialCompany" in companyToNormalize;

    if (isPartial) {
      const partial = companyToNormalize.partialCompany ?? {};

      return {
        ...companyToNormalize,
        name: partial.name ?? "-",
        email: partial.email ?? "-",
        vatNumber: partial.vatNumber ?? "-",
        leiNumber: partial.leiNumber ?? "-",
        eoriNumber: partial.eoriNumber ?? "-",
        phone: partial.phone ?? "-",
        address: partial.address ?? [],
        country: partial.country ?? "-",
        language: partial.language?.name ?? "-",
        defaultCurrency: partial.defaultCurrency ?? "-",
        companyType: partial.companyType ?? "-",
        timeZone: partial.timeZone ?? "-",
        membershipType: partial.membershipType ?? "-",
        creditLimit: partial.creditLimit ?? "-",
        invoiceDaysBeforeDueDate: `${partial?.invoiceDaysBeforeDueDate} ${t("common:days")}`,
        settlementDays: `${partial?.settlementDays} ${t("common:days")}`,
        bankAccount: partial.bankAccount ?? [],
      };
    }

    return {
      ...companyToNormalize,
      name: companyToNormalize.companyName ?? "-",
      email: companyToNormalize.email ?? "-",
      vatNumber: companyToNormalize.vatNumber ?? "-",
      leiNumber: companyToNormalize.leiNumber ?? "-",
      eoriNumber: companyToNormalize.eoriNumber ?? "-",
      phone: companyToNormalize.phone ?? "-",
      address: companyToNormalize.companyAddress ?? [],
      country: companyToNormalize.companyCountryCode?.name ?? "-",
      language: companyToNormalize.language?.name ?? "-",
      defaultCurrency: companyToNormalize.defaultCurrency ?? "-",
      companyType: companyToNormalize.companyType ?? "-",
      timeZone: companyToNormalize.timeZone ?? "-",
      membershipType: companyToNormalize.membership ?? "-",
      creditLimit: companyToNormalize.credit.creditLimit ?? "-",
      invoiceDaysBeforeDueDate: "-",
      settlementDays: "-",
      bankAccount: companyToNormalize.bankAccount ?? [],
    };
  }, [companyToNormalize]);
}
